export interface IVendorContact {
    id: string;
    name: string;
    role: string;
    location: string;
    email: string;
    phone: string;
    function: string;
    isPrimary: boolean;
}

export const mockContacts: IVendorContact[] = [
    {
        id: '1',
        name: 'John Smith',
        role: 'Account Manager',
        location: 'New York, NY',
        email: 'john.smith@example.com',
        phone: '+1 (212) 555-1234',
        function: 'Business Development',
        isPrimary: true
    },
    {
        id: '2',
        name: 'Sarah Johnson',
        role: 'Account Manager',
        location: 'Los Angeles, CA',
        email: 'sarah.johnson@example.com',
        phone: '+1 (310) 555-6789',
        function: 'Finance',
        isPrimary: false
    },
    {
        id: '3',
        name: 'Michael Chen',
        role: 'Legal Counsel',
        location: 'San Francisco, CA',
        email: 'michael.chen@example.com',
        phone: '+1 (415) 555-9876',
        function: 'Legal',
        isPrimary: false
    },
    {
        id: '4',
        name: 'Emily Rodriguez',
        role: 'Legal Counsel',
        location: 'Miami, FL',
        email: 'emily.rodriguez@example.com',
        phone: '+1 (305) 555-4321',
        function: 'Legal',
        isPrimary: true
    },
    {
        id: '5',
        name: 'David Kim',
        role: 'Account Manager',
        location: 'Chicago, IL',
        email: 'david.kim@example.com',
        phone: '+1 (312) 555-8765',
        function: 'Finance',
        isPrimary: false
    },
    {
        id: '6',
        name: 'Lisa Wang',
        role: 'Legal Counsel',
        location: 'Nashville, TN',
        email: 'lisa.wang@example.com',
        phone: '+1 (615) 555-2345',
        function: 'Legal',
        isPrimary: false
    },
    {
        id: '7',
        name: 'Robert Taylor',
        role: 'Account Manager',
        location: 'Austin, TX',
        email: 'robert.taylor@example.com',
        phone: '+1 (512) 555-7890',
        function: 'Business Development',
        isPrimary: false
    },
    {
        id: '8',
        name: 'Jennifer Martinez',
        role: 'Account Manager',
        location: 'Seattle, WA',
        email: 'jennifer.martinez@example.com',
        phone: '+1 (206) 555-3456',
        function: 'Finance',
        isPrimary: false
    }
];
